module.exports = __webpack_public_path__ + "img/87.48c244d9.jpg";